React = require 'react'
Helmet = require 'react-helmet'
config = require 'config'

module.exports = React.createClass
  getInitialState: ->
    count: 0

  handlePlusClick: ->
    @setState count: @state.count + 1

  handleMinusClick: ->
    @setState count: @state.count - 1

  render: ->
    React.createElement("div", null,
      React.createElement(Helmet, { \
        "title": (config.config.siteTitle + ' | Coffeescript React.js components') 
      }),
      React.createElement("h1", null, "Coffeescript React.js components"),
      React.createElement("h3", null, "Counter example"),
      React.createElement("p", null, (@state.count)),
      React.createElement("button", {"onClick": (@handlePlusClick)}, "+"),
      React.createElement("button", {"onClick": (@handleMinusClick)}, "-")
    )



// WEBPACK FOOTER //
// ../~/cjsx-loader!./coffee-react.cjsx